import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../../i18n/translations";

export const Pricing = ({ t }) => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative bg-zinc-950 py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-5">
            <span className="overline">{t.pricing.overline}</span>
            <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-zinc-50">
              {t.pricing.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="font-body text-zinc-400 text-base md:text-lg leading-relaxed">
              {t.pricing.subtitle}
            </p>
          </div>
        </div>

        <div className="border border-zinc-800">
          {t.pricing.items.map((item, i) => (
            <div
              key={item.name}
              data-testid={`pricing-row-${i}`}
              className={`grid grid-cols-12 items-center px-6 md:px-8 py-5 md:py-6 transition-colors hover:bg-zinc-900/60 ${
                i !== t.pricing.items.length - 1
                  ? "border-b border-zinc-900"
                  : ""
              }`}
            >
              <span className="col-span-1 font-body text-xs font-bold text-zinc-600 tracking-wider">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="col-span-7 md:col-span-8 font-heading text-base md:text-xl font-medium text-zinc-100 tracking-tight">
                {item.name}
              </span>
              <span className="col-span-4 md:col-span-3 text-right font-heading text-base md:text-xl font-semibold text-red-600 tracking-tight">
                {item.price}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-body text-xs text-zinc-500 tracking-wide">
            {t.pricing.note}
          </p>
          <a
            data-testid="pricing-quote-cta"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 text-zinc-950 font-body font-bold text-sm tracking-wider uppercase px-7 py-4 transition-colors"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={2.6} />
            {t.pricing.cta}
          </a>
        </div>
      </div>
    </section>
  );
};
